import nodule1 from "./nodule1";
import nodule2 from "./nodule2";
import nodule3 from "./nodule3";
import nodule4 from "./nodule4";
// import nodule5 from "./nodule5";
// import nodule6 from "./nodule6";

export default {
  nodule1,
  nodule2,
  nodule3,
  nodule4,
  // nodule5,
  // nodule6,
};
